module.exports = __webpack_public_path__ + "static/media/Data_ARQUI._E_DESEN._EM_BLOCKCHAIN.392c4770.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/arquiDesenBlockchain/Data_ARQUI._E_DESEN._EM_BLOCKCHAIN.png
// module id = 244
// module chunks = 0